module.exports = __webpack_public_path__ + "img/product_115.0ed0dee.webp";